import { get, writable } from "svelte/store";
import { rgbToNegativeFloats, rgbToFloats } from "./utils";
import Viva from "vivagraphjs";

// Graph
export const graph = Viva.Graph.graph();
export const layout = Viva.Graph.Layout.forceDirected(graph, {
  springLength: 200,
  springCoeff: 0.00005,
  dragCoeff: 0.02,
  gravity: -2,
  theta: 0.95,
});
// "labels" store
export const labels = writable([]);
// Cluster
let uid = 0;
class Cluster {
  constructor(label, items) {
    Object.assign(this, label);
    this.uid = uid++;
    this.node = graph.addNode(this.id, label);
    this.body = layout.getBody(this.id);

    this.links = [];
    this.nodes = [];
    this.bodies = [];

    let index = this.id + 1;
    items.forEach((item) => {
      item.neg = rgbToNegativeFloats(item.col);
      item.col = rgbToFloats(this.color); //rgbToFloats(item.col);

      let node = graph.addNode(index);
      node.data = item;
      node.cluster = this;
      this.nodes.push(node);

      let body = layout.getBody(index);
      node.body = body;
      body.origin = { x: item.x, y: item.y };
      this.bodies.push(body);

      index++;
    });

    this.reset();
  }

  clearLinks() {
    this.links.forEach((link) => {
      graph.removeLink(link);
    });
    this.links = [];
  }

  reset() {
    this.body.pos.x = this.x;
    this.body.pos.y = this.y;
    this.bodies.forEach((body) => {
      body.pos.x = body.origin.x * 100;
      body.pos.y = body.origin.y * 100;
    });
  }

  resetLinks(limit = 1) {
    const _labels = get(labels);
    this.clearLinks();
    this.nodes.forEach((node, k) => {
      node.data.stats.forEach((e, i) => {
        if (i > limit) return;
        let link = graph.addLink(node.id, _labels[e.cat].id);
        link.alpha = _labels[e.cat].id == this.id ? 0 : 1;
        this.links.push(link);
      });
    });
  }
}
// Custom "clusters" store
function Clusters() {
  const { subscribe, set, update } = writable([]);
  let nodeId = 0;

  return {
    add: (label, items) => {
      label.id = nodeId++;
      nodeId += items.length;
      update((clusters) => [...clusters, new Cluster(label, items)]);
    },
    clearLinks: () => {
      update((clusters) => {
        clusters.forEach((cluster) => {
          cluster.clearLinks();
        });
        return clusters;
      });
    },
    reset: (limit = 1) => {
      update((clusters) => {
        clusters.forEach((cluster) => {
          cluster.resetLinks(limit);
          cluster.reset();
        });
        return clusters;
      });
    },
    resetLinks: (limit = 1) => {
      update((clusters) => {
        clusters.forEach((cluster) => {
          cluster.resetLinks(limit);
        });
        return clusters;
      });
    },
    subscribe,
    update,
  };
}
export const clusters = Clusters();